import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

export function AppIconWallet({ size = 20, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  return (
    <Svg width={size} height={size} viewBox="0 0 17 16.9941" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
        d="M6.38086 6.0918C7.67778 3.57263 10.3342 4.82703 10.8145 5.74023C11.4749 6.90447 11.4411 7.69972 11.2031 8.74609C10.9414 9.89933 10.219 10.785 9.43848 11.6104C8.08494 13.042 7.22792 14.6876 6.92383 16.5723C6.91139 16.6494 6.90627 16.8258 6.90723 16.9941C5.58432 16.9783 4.76593 16.9174 4.07129 16.6816C3.97197 16.6479 3.87419 16.6109 3.77734 16.5723C3.84243 16.1423 3.92247 15.6327 3.96094 15.4668C4.01012 15.3105 4.06611 15.1541 4.12402 15C4.50579 13.986 5.09295 13.1046 5.74023 12.2451C6.58499 11.1176 6.62815 9.85423 6.26367 8.52734C6.02139 7.64847 6.01209 6.80773 6.38086 6.0918ZM8.42871 6.0918C8.01931 6.10903 7.68519 6.46678 7.7002 6.87207C7.71715 7.27927 8.07718 7.61362 8.48438 7.59863C8.88723 7.58359 9.23086 7.21903 9.21582 6.81836C9.20068 6.41312 8.83588 6.07677 8.42871 6.0918Z"
      />
      <Path
        fill={fill}
        d="M8.5 0C10.8271 0 11.9907 0.000916779 12.9287 0.319336C14.695 0.918966 16.0821 2.30599 16.6816 4.07227C16.9999 5.01023 17 6.17423 17 8.50098C17 10.8274 16.9999 11.9908 16.6816 12.9287C16.4157 13.7121 15.9933 14.42 15.4531 15.0186C15.3112 14.6882 15.1677 14.3404 15.1406 14.2168C14.5472 11.5071 14.7196 9.93561 14.5459 7.50879C14.5459 4.92261 12.592 2.9156 10.1309 2.66699C8.79972 2.53202 7.52183 2.85177 6.55078 3.78418C4.99759 5.12532 1.76352 4.86757 1.75879 4.86719C1.76591 4.86893 4.28935 5.48805 4.58887 7.44434C4.67009 7.97599 4.78392 8.50366 4.92969 9.02246C5.24061 10.1224 5.05019 11.0917 4.33203 11.9707C3.674 12.7726 3.1698 13.6688 2.81836 14.6143C2.69488 14.9011 2.56077 15.3516 2.44531 15.8311C1.46792 15.1117 0.717712 14.1052 0.318359 12.9287C9.46522e-05 11.9908 1.55746e-09 10.8274 0 8.50098C0 6.17423 7.236e-05 5.01023 0.318359 4.07227C0.91793 2.30599 2.30504 0.918966 4.07129 0.319336C5.00932 0.000916779 6.17293 0 8.5 0Z"
      />
    </Svg>
  )
}
